<template>
    <b-card :title="$translate('filters')" body-class="p-0 mt-3" class="text-center warehouse-filter" title-tag="h5">
        <b-card-body class="p-0">
            <b-row class="query-filter mb-3">
                <b-col md="4" cols="12" class="dd mt-3 text-start">
                    <label for="input-location" class="mb-3"><strong>{{ $translate('warehouse_location') }}</strong></label>
                    <b-form-select class="form-control" id="input-location" v-model="sectionItemsFilter.location_id"
                        :options="locations" value-field="id" text-field="name" block>
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_all') }}
                            </b-form-select-option>
                        </template>
                        <template>
                            <b-form-select-option :value="officerOption">
                                ({{ $translate('officers') }})
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="4" cols="12" class="dd mt-3 text-start">
                    <label for="input-type" class="mb-3"><strong>{{$translate('item_type')}}</strong></label>
                    <b-form-select class="form-control" id="input-type" v-model="sectionItemsFilter.order_item_type_id"
                        :options="types" value-field="id" text-field="name" block>
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_all') }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="4" cols="12" class="dd mt-3 text-start">
                    <label for="input-officers" class="mb-3"><strong>{{$translate('officers')}}</strong></label>
                    <b-form-select :disabled="sectionItemsFilter.location_id !== officerOption
                        " class="form-control" id="input-1" v-model="sectionItemsFilter.officer_id" :options="officers"
                        value-field="id" text-field="name" block>
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_all') }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="Product" class="mb-3"><strong>{{$translate('product')}}</strong></label>
                    <b-form-input id="input-product" v-model="sectionItemsFilter.product_search" value-field="id"
                        text-field="name" :placeholder="$translate('keyword_search')" block>
                    </b-form-input>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-section" class="mb-3"><strong>{{$translate('section')}}</strong></label>
                    <b-form-input id="input-section" v-model="sectionItemsFilter.section_search" value-field="id"
                        text-field="name" :placeholder="$translate('keyword_search')" block :disabled="sectionItemsFilter.location_id == officerOption
                            ">
                    </b-form-input>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="input-quantity" class="mb-3"><strong>{{$translate('quantity')}}</strong>
                    </label>

                    <b-input-group>
                        <b-form-input id="input-quantity" type="number"
                            v-model="sectionItemsFilter.quantity"></b-form-input>
                        <template #prepend>
                            <div class="customselect">
                                <select class="form-control" v-model="sectionItemsFilter.quantityType" value-field="id"
                                    text-field="name" block>
                                    <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                        {{ x.name }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'inventoryTransfer-queryfilters',
    mixins: [permissionsMixins],

    props: ['locations', 'types', 'officers', 'value', 'officerOption'],
    data() {
        return {
            quantities: [
                { id: 1, name: '=' },
                { id: 2, name: '>' },
                { id: 3, name: '<' },
            ],
        }
    },
    computed: {

        sectionItemsFilter: {
            get() {
                console.log('...........', this.value)
                return this.value || {}
            },
            set(newvalue) {
                this.$emit('input', newvalue)
            },
        },
    },
    watch: {
        'sectionItemsFilter.location_id': function () {
            this.sectionItemsFilter.officer_id = null
            this.sectionItemsFilter.section_search = ''
        },
    },
    mounted() {},
    methods: {},
}
</script>